import { Col, Form, Row } from 'antd';
import React, { useEffect } from 'react';
import ZenFormInput from './InputCreater/ZenFormInput';
import StablePrime from '../components/Tables/StablePrime';
import ButtonPicker from '../components/ReportFormGenerator/Button/Button';
import liracrypt from '../components/Liracrypt/liracrypt';

const RandomDataG = ({
    setPageHeader,
    urlData = {}
}) => {
    const [form] = Form.useForm();
    const [initVal, setInitVal] = React.useState();
    const [formValues, setFormValues] = React.useState();
    const [countdown, setCountdown] = React.useState(null);
    const countdownRef = React.useRef();
    const [pulse, setPulse] = React.useState(0);
    const [elements, setElements] = React.useState();
    const [api, setApi] = React.useState("");
    const [pulseCount, setPulseCount] = React.useState(0);
    const [apiPulse, setApiPulse] = React.useState("");
    useEffect(() => {
        setPageHeader("Random Data Generator");
        liracrypt.get('/miscellaneous/pageconfig', { dictName: 'RandomDataGenerator', ...urlData })
            .then(({ data }) => {
                setElements(data?.config?.modalElements);
                setApi(data?.config?.url);
                setApiPulse(data?.config?.urlPulse);
            }).catch(err => {
                console.log(err);
            })
    }, []);

    useEffect(() => {
        if (countdown !== null && countdown > 0) {
            countdownRef.current = setTimeout(() => {
                setCountdown(prev => {
                    const next = (parseFloat(prev) - 0.1).toFixed(1);
                    return next >= 0 ? next : 0;
                });
            }, 100);
        } else if (countdown === 0 || countdown === '0.0') {
            if (pulse === 0) return;
            setTimeout(() => {
                setFormValues(null);
            }, 500)
            setTimeout(() => {
                setPulse(prev => prev - 1);
                const from = parseFloat(initVal?.from);
                const to = parseFloat(initVal?.to);
                const randomDecimal = (Math.random() * (to - from) + from).toFixed(1);
                setCountdown(randomDecimal);
                setFormValues({ ...initVal, randomDecimal });
            }, 1000);

        }
        return () => clearTimeout(countdownRef.current);
    }, [countdown]);

    const onFinish = (values) => {
        setFormValues(null);
        setTimeout(() => {
            const from = parseFloat(values.from);
            const to = parseFloat(values.to);
            const randomDecimal = (Math.random() * (to - from) + from).toFixed(1);
            setInitVal({ ...values })
            setFormValues({ ...values, randomDecimal });
            setCountdown(randomDecimal);
            setPulse(values.pulse - 1);
            setPulseCount(values.pulse);
        }, 200)

    };

    const DataTable = () => {
        if (formValues) {
            return (
                <div style={{ padding: 10 }}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: 20
                    }}>
                        <span style={{
                            fontFamily: 'monospace, "Orbitron", "Courier New", Courier, sans-serif',
                            fontSize: 120,
                            color: '#00ffe7',
                            //   textShadow: '0 0 5px #00ffe7, 0 0 5px #00ffe7, 0 0 5px #00ffe7',
                            letterSpacing: '2px',
                            fontWeight: 700,
                            lineHeight: 1,
                            userSelect: 'none'
                        }}>
                            {
                                (() => {
                                    const [min, sec] = String(countdown).split('.');
                                    return `${min.padStart(2, '0')}:${(sec || '0').padStart(2, '0')}`;
                                })()
                            }
                        </span>
                    </div>
                    <StablePrime zenTable={true} url={(pulseCount - pulse) === 1 ? api : apiPulse} data={{ ...urlData, ...formValues, pulseCount: (pulseCount - pulse) }} identity="randomdatagenerator" />
                </div >
            )
        }
    }

    return (
        <div>
            <div
                className="AuditSection CreateAudit"
                style={{ padding: 20 }}
            >
                <div className="ThemeForm">
                    <Form
                        labelWrap={true}
                        name={"ReportForm"}
                        form={form}
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 16 }}
                        layout="horizontal"
                        colon={false}
                        onFinish={onFinish}
                        size="large"
                    >
                        <Row>
                            {
                                elements?.map((data, idx) => (
                                    <React.Fragment key={idx}>
                                        <ZenFormInput
                                            pageType={"phantom"}
                                            onChange={(data.typ === 'dropDown' && data.submitOnChange) ? () => form.submit() : undefined}
                                            colSpan={data.colSize || 12}
                                            form={form}
                                            name={data["data_index"]}
                                            pname={data["p_data_index"]}
                                            label={data["label"]}
                                            defaultValue={data["default"]}
                                            defaultFrom={data["defaultFrom"]}
                                            defaultTo={data["defaultTo"]}
                                            typ={data["typ"]}
                                            disabled={data["readOnly"]}
                                            source={data["source"]}
                                            sourceParams={data["sourceParams"]}
                                            auxParams={data["auxParams"]}
                                            format={data["format"]}
                                            errorMessage={data["errorMessage"]}
                                            placeHolder={data["placeHolder"]}
                                            required={data["required"]}
                                            options={data["data"]}
                                            from={data["data_index_from"]}
                                            to={data["data_index_to"]}
                                            url={data["url"]}
                                            includeAll={data["includeAll"]}
                                            multiSelect={data["multiSelect"]}
                                            // searchable={data["isSearchable"]}
                                            searchable={true}
                                            data={data}

                                        />
                                    </React.Fragment>
                                ))
                            }
                        </Row>
                        <div style={{ paddingTop: 20 }}>
                            <ButtonPicker
                                submitBtnId={"phantomPrimeSbmt"}
                                form={form}
                                // hide_submit={config?.hide_submit}
                                // marginLeft={btnMargin ? btnMargin : "320px"}
                                loading={false}
                                cancelButtonText={"Reset"}
                                submitButtonText={"Submit"}
                            //  resetButton={true}
                            />
                        </div>
                    </Form>
                </div>
            </div>
            {
                formValues && (
                    <>
                        {DataTable()}
                    </>
                )
            }
        </div>
    );
}

export default RandomDataG;